import config from 'config';

/**
 * Returns the RB (resource bundle) key, optionally suffixed with a country code
 *
 * @param {string} rbKey - Base resource bundle key
 * @param {string} countryCode - ISO country code (e.g. 'DE', 'FR')
 * @returns {string} The resolved RB key
 */
export function getLocalizedRbKey(rbKey, countryCode) {
  const customLocalizedCountryCodes = config.get(
    'public.brand.useCustomLocalizedRbs'
  );

  if (
    !Array.isArray(customLocalizedCountryCodes) ||
    !customLocalizedCountryCodes?.length
  ) {
    return rbKey;
  }

  if (customLocalizedCountryCodes.includes(countryCode)) {
    return `${rbKey}_${countryCode?.toLowerCase()}`;
  }

  return rbKey;
}
